module.exports = __webpack_public_path__ + "media/entities/1141-4024c463.png";